import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ProductsService } from 'shared-data-access';
import { Router } from '@angular/router';
import { LineOfBusiness } from 'identity-management';
import { AppRoutes, PRODUCT_ROUTES } from 'shared-utils';

@Injectable()
export class JourneyHeadersInterceptor implements HttpInterceptor {
  private productsService = inject(ProductsService);
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const product: LineOfBusiness = this.productsService.selectedProduct;
    if (this.isRouteJourneyRelated(this.router.url) && product) {
      const journeyHeaders: Record<string, string | string[]> = {
        'content-type': 'application/json',
        lobId: product.lob.toUpperCase(),
      };
      const reqClone: HttpRequest<unknown> = request.clone({
        setHeaders: journeyHeaders,
      });
      return next.handle(reqClone);
    } else {
      return next.handle(request);
    }
  }

  private isRouteJourneyRelated(url: string): boolean {
    const isRootRoute = url === '/';
    const isProductsRoute: boolean = url.includes(AppRoutes.Products);
    const isContractsRoute: boolean = url.includes(AppRoutes.Contracts);

    return isRootRoute || isProductsRoute || isContractsRoute || this.isRouteWithinUrl(this.router.url, PRODUCT_ROUTES);
  }

  private isRouteWithinUrl(url: string, routes: string[]): boolean {
    const urlParts: string[] = url.split('/');
    return routes.some((route: string) =>
      urlParts.some((_: string, idx: number, array: string[]): boolean =>
        array
          .slice(0, idx + 1)
          .join('/')
          .includes(route)
      )
    );
  }
}
